import i18n from '@/i18n';
import { Directive, DirectiveBinding } from 'vue';
import { City } from './../collections/cities/city.interface';

interface Address {
   city: City;
   street: string;
   house_number: string | number;
   box?: string;
}

export function formatAddress(address: any, wrap = false) {
   const box = address.box ? `${i18n.global.t('generic.address.box')}: ${address.box}` : '';

   return `${address?.street || ''} ${address?.house_number || ''} ${box} ${wrap && address.street ? '<br>' : ''} ${
      address?.city?.postal_code || ''
   } ${address?.city?.name || ''}`.trim();
}

function addressFormatter(el: HTMLElement, { value, arg }: DirectiveBinding<Address>) {
   if (!value) {
      return (el.innerHTML = '');
   }

   if (!value?.street && !value?.house_number && !value?.box && !value?.city?.postal_code && !value?.city?.name) {
      return (el.innerHTML = '-');
   }

   el.innerHTML = formatAddress(value, arg === 'wrap');
}

const AddressFormatter: Directive = {
   mounted: addressFormatter,
   updated: addressFormatter,
};

export default AddressFormatter;
